





































































import { Component, Vue, Prop } from 'nuxt-property-decorator';

import { PerformanceEvent, usePerformanceUpcomingEvents } from '@/composables/performance-events';
import { capitalizeFirst } from '@/composables/utils';
import { formatSv } from '@/composables/datefns';

@Component({
  setup (props: any) {
    return usePerformanceUpcomingEvents(props.performanceId, 6);
  },
})
export default class ShowHeader extends Vue {
  performanceUpcomingEvents!: PerformanceEvent[];
  performanceUpcomingEventsLoading!: boolean;

  @Prop({ type: String, required: true })
  performanceId!: string;

  @Prop({ type: String, required: true })
  title!: string

  @Prop(String)
  subtitle!: string

  @Prop()
  image;

  @Prop(String)
  videoLoop!: string

  @Prop(String)
  videoTitle!: string

  @Prop(String)
  videoLength!: string

  @Prop(String)
  vimeoId!: string

  @Prop(String)
  youtubeId!: string

  @Prop({ type: Boolean, default: false })
  hideButton: boolean

  eventModalOpen = false;
  modalOpen = false;

  get videoLabelId () {
    return `show-header-${this.vimeoId ? this.vimeoId : this.youtubeId}-label`;
  }

  get shows () {
    return this.performanceUpcomingEvents.map((event) => {
      const startDate = new Date(event.startDate);
      // const endDate = new Date(event.endDate);
      return {
        title: capitalizeFirst(formatSv(startDate, 'EEEE d MMMM')),
        subtitle: `Kl. ${formatSv(startDate, 'HH:mm')} i ${event.locationStage}`,
        time: `Kl. ${formatSv(startDate, 'HH:mm, cccc d MMMM')}`,
        location: event.locationStage,
        cancelled: false,
        soldOut: false,
        bookingLink: event.purchaseUrl,
      };
    });
  }

  get singleEventBookingLink () {
    if (this.shows.length === 1)
      return this.performanceUpcomingEvents.map((event) => {
        return event.purchaseUrl;
      }).join('');
  }

  get timeAndLocation () {
    if (this.shows.length <= 1) {
      return `${this.shows[0].time} i ${this.shows[0].location}`;
    } else {
      const arenas = [];
      this.shows.forEach((show) => {
        if (!arenas.includes(show.location))
          arenas.push(show.location);
      });
      return arenas.join('\r\n');
      // return this.shows[0].location;
    }
  }

  toggleModalOpen () {
    this.modalOpen = !this.modalOpen;
  }

  openModal (e: boolean) {
    this.eventModalOpen = e;
  }
}
